import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { Icon } from '../Icon';
// import CustomLink from '../CustomLink';
// import { TERMS_OF_USE_LINK } from '../../shared/links';
import styles from './UpsellOfferSpecialV3.css';

const cx = classnames.bind(styles);

const PRICE = '$29.99';

function UpsellOfferSpecialV3({
    className,
    onBuy,
    isPending,
    skipUrl,
    onSkip
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <article className={classes}>
            <header className={styles.discountBanner}>
                <Icon name='discountBadge' className={styles.discountIcon} />
                NEW MEMBER DISCOUNT
            </header>
            <div className={styles.body}>
                <div className={styles.priceGuaranteeBlock}>
                    <div className={styles.priceRow}>
                        <p className={styles.price}>{PRICE}</p>
                        <p className={styles.priceSecondary}>one-time payment</p>
                    </div>
                    {/* <p className={styles.guarantee}>
                        <Icon name='shieldCheck' className={styles.guaranteeIcon} />
                        <span>
                            30-day
                            {' '}
                            <CustomLink
                                to={TERMS_OF_USE_LINK}
                                target='_blank'
                                withDefaultClassName={false}
                                className={styles.guaranteeLink}
                            >
                                money-back guarantee
                            </CustomLink>
                            {' '}
                            — we refund every cent, no questions asked
                        </span>
                    </p> */}
                </div>
                <ul className={styles.features}>
                    <li>
                        <Icon name='clockOutline' />
                        Instant 24/7 response
                    </li>
                    <li>
                        <Icon name='mapPin' />
                        US-based advisors
                    </li>
                    <li>
                        <Icon name='userOutline' />
                        No bots, real humans
                    </li>
                    <li>
                        <Icon name='musicNoteOff' />
                        No hold music
                    </li>
                </ul>
                <div className={styles.buttonsBlock}>
                    <p className={styles.terms}>
                        By clicking Buy Now, you agree that you will be automatically charged using the same billing method you provided at the checkout.
                    </p>
                    <Button
                        label='Buy now'
                        onClick={onBuy}
                        isLoading={isPending}
                        className={styles.button}
                    />
                    <Button
                        label='SKIP'
                        type='secondary'
                        link={{ to: skipUrl }}
                        onClick={onSkip}
                        className={styles.skipButton}
                    />
                </div>
            </div>
        </article>
    );
}

UpsellOfferSpecialV3.propTypes = {
    className: PropTypes.string,
    onBuy: PropTypes.func.isRequired,
    isPending: PropTypes.bool.isRequired,
    skipUrl: PropTypes.string.isRequired,
    onSkip: PropTypes.func.isRequired
};

UpsellOfferSpecialV3.defaultProps = {
    className: ''
};

export {
    UpsellOfferSpecialV3
};
